import { useUserState } from './context/useUserState';
import { useTranslate } from './context/useTranslate';

export const useVenueTitle = () => {
  const {
    state: { venueName, venueNameStatus },
  } = useUserState();
  const { t } = useTranslate();

  if (venueNameStatus === 'loading') {
    return { title: t('venueNameLoading'), isLoading: true };
  }

  return {
    title: venueName || t('venueNameUnavailable'),
    isLoading: false,
  };
};
